import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { useSetAtom } from 'jotai';
import React from 'react';
import { ScrollView, View } from 'react-native';
import styled from 'styled-components/native';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import { SccTouchableOpacity } from '@/components/SccTouchableOpacity';
import { useNearbyConqueredCount } from '@/hooks/useNearbyAccessibilityStatus';
import { filterAtom, SortOption } from '../atoms';
import SearchCategoryIcon from './SearchHeader/SearchCategoryIcon';
const recommendPlaces = [
    {
        status: 'stair1_restaurant',
        description: '계단 1칸 이하 음식점',
        keyword: '음식점',
        category: 'RESTAURANT',
        hasSlope: null,
        isRegistered: true,
        scoreUnder: 1,
        hasReview: null,
    },
    {
        status: 'stair1_cafe',
        description: '계단 1칸 이하 카페',
        keyword: '카페',
        category: 'CAFE',
        hasSlope: null,
        isRegistered: true,
        scoreUnder: 1,
        hasReview: null,
    },
    {
        status: 'ramp_restaurant',
        description: '경사로 있는 음식점',
        keyword: '음식점',
        category: 'RESTAURANT',
        hasSlope: true,
        isRegistered: true,
        scoreUnder: 1,
        hasReview: null,
    },
    {
        status: 'ramp_cafe',
        description: '경사로 있는 카페',
        keyword: '카페',
        category: 'CAFE',
        hasSlope: true,
        isRegistered: true,
        scoreUnder: 1,
        hasReview: null,
    },
    {
        status: 'unconquered_restaurant',
        description: '정복 안 된 음식점',
        keyword: '음식점',
        category: 'RESTAURANT',
        hasSlope: null,
        isRegistered: false,
        scoreUnder: null,
        hasReview: null,
    },
    {
        status: 'unconquered_cafe',
        description: '정복 안 된 카페',
        keyword: '카페',
        category: 'CAFE',
        hasSlope: null,
        isRegistered: false,
        scoreUnder: null,
        hasReview: null,
    },
];
const ColorMap = {
    stair1_restaurant: { background: '#EEFAEF', scoreLabelText: '#059D00' },
    stair1_cafe: {
        background: '#FDF8EA',
        scoreLabelText: '#E88B00',
        iconColor: '#FFBF00',
    },
    ramp_restaurant: { background: '#F5EEFA', scoreLabelText: '#88009D' },
    ramp_cafe: { background: '#EBF5FF', scoreLabelText: '#0E64D3' },
    unconquered_restaurant: { background: '#E7E7E7', scoreLabelText: '#312E2E' },
    unconquered_cafe: { background: '#E7E7E7', scoreLabelText: '#312E2E' },
};
export default function SearchRecommendPlace({ onPressKeyword, }) {
    // 홈이 프리페치해둔 같은 캐시를 구독한다 (중복 호출 제거).
    const { data } = useNearbyConqueredCount();
    const setFilter = useSetAtom(filterAtom);
    if (!data || data < 10) {
        return null;
    }
    function onPressFilter({ hasSlope, isRegistered, scoreUnder, hasReview, keyword, }) {
        setFilter({
            hasSlope,
            isRegistered,
            scoreUnder,
            hasReview,
            sortOption: SortOption.LOW_SCORE,
        });
        onPressKeyword === null || onPressKeyword === void 0 ? void 0 : onPressKeyword(keyword);
    }
    return (_jsxs(View, { style: { gap: 12 }, children: [_jsx(TitleText, { children: "\uB0B4 \uC8FC\uBCC0 \uC5EC\uAE30\uB294 \uC5B4\uB5A0\uC138\uC694?" }), _jsx(ScrollView, { horizontal: true, showsHorizontalScrollIndicator: false, style: { overflow: 'visible' }, contentContainerStyle: {
                    flexDirection: 'row',
                    gap: 6,
                    flexWrap: 'nowrap',
                }, children: recommendPlaces.map(({ description, keyword, category, hasSlope, isRegistered, scoreUnder, hasReview, status, }, idx) => (_jsxs(RecommendPlaceItem, { elementName: "recommend_place", logParams: { keyword, category, status, description, index: idx }, status: status, onPress: () => onPressFilter({
                        scoreUnder,
                        hasSlope,
                        isRegistered,
                        hasReview,
                        keyword,
                    }), children: [_jsxs(View, { style: { flexDirection: 'row', alignItems: 'center', gap: 2 }, children: [_jsx(SearchCategoryIcon, { icon: category, size: 16, color: ColorMap[status].iconColor
                                        ? ColorMap[status].iconColor
                                        : ColorMap[status].scoreLabelText, isOn: category === 'CAFE' }), _jsx(ScoreLabelText, { status: status, children: scoreUnder
                                        ? `접근 레벨 ${scoreUnder} 이하`
                                        : '정복이 필요해!' })] }), _jsx(Text, { children: description })] }, `recommend-place-${description}-${idx}`))) })] }));
}
const TitleText = styled.Text `
  font-size: 14px;
  font-family: ${() => font.pretendardBold};
  color: ${color.black};
`;
const RecommendPlaceItem = styled(SccTouchableOpacity) `
  padding: 10px 12px;
  border-radius: 8px;
  background-color: ${({ status }) => ColorMap[status].background};
  gap: 2px;
`;
const ScoreLabelText = styled.Text `
  font-size: 12px;
  font-family: ${font.pretendardRegular};
  color: ${({ status }) => ColorMap[status].scoreLabelText};
`;
const Text = styled.Text `
  font-size: 15px;
  font-family: ${font.pretendardMedium};
  color: ${color.black};
  line-height: 22px;
`;
